module.exports = __webpack_public_path__ + "static/email-marketing-campaigns-d28993492870d282b5e44643081c3d02.svg";